<template>
    <div class="fa-2x text-center text-secondary py-5">
        <i class="fas fa-circle-notch fa-spin"></i>
    </div> 
</template>

<script>
    export default {}
</script>